import { Value } from 'firebase/remote-config';

/**
 *
 *  this function parse remoteConfig response to be able to set in context
 *  @param remoteData obtained object from getAll(), the keys may contain Json or other types of data
 *
 */
const parseRemoteData = (
  remoteData: Record<string, Value>
): Record<string, string | number | boolean> => {
  const parsed: Record<string, string | number | boolean> = {};

  Object.keys(remoteData).forEach((key) => {
    const raw = remoteData[key].asString();

    if (raw === 'true' || raw === 'false') {
      parsed[key] = raw === 'true';
    } else if (!isNaN(Number(raw)) && raw.trim() !== '') {
      parsed[key] = Number(raw);
    } else {
      parsed[key] = raw;
    }
  });

  return parsed;
};
export default parseRemoteData;
